import React from 'react';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon, TrashIcon } from 'lucide-react';
import { CartItem as CartItemType } from '../../types';
import { formatPrice } from '../../utils/formatters';
import { useCart } from '../../context/CartContext';
interface CartItemProps {
  item: CartItemType;
}
export function CartItem({
  item
}: CartItemProps) {
  const {
    updateQuantity,
    removeItem
  } = useCart();
  const {
    product,
    quantity
  } = item;
  return <div className="flex gap-4 py-4 border-b border-gray-100 last:border-0" data-id="element-41" data-mp="2gflj3mgrflc0">
      {/* Image */}
      <Link to={`/product/${product.slug}`} className="flex-shrink-0" data-id="element-42" data-mp="2u6ibpdaos2j2">
        <img src={product.images[0]} alt={product.name} className="w-20 h-20 md:w-24 md:h-24 object-cover rounded-lg" data-id="element-43" data-mp="2u8uufso9qgx6" />
      </Link>

      {/* Details */}
      <div className="flex-1 min-w-0" data-id="element-44" data-mp="345zenmyk02bc">
        <Link to={`/product/${product.slug}`} data-id="element-45" data-mp="342tt2hp4vikd">
          <h3 className="font-medium text-gray-900 hover:text-primary-600 transition-colors line-clamp-2" data-id="element-46" data-mp="2z6mjmexj3oxo">
            {product.name}
          </h3>
        </Link>
        <p className="text-sm text-gray-500 mt-1" data-id="element-47" data-mp="e32lia2zcz6u">{product.brand}</p>

        <div className="flex items-center justify-between mt-3" data-id="element-48" data-mp="j02vgw2yam38">
          {/* Quantity controls */}
          <div className="flex items-center gap-2" data-id="element-49" data-mp="nxm7dpc6ems0">
            <button onClick={() => updateQuantity(product.id, quantity - 1)} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition-colors" aria-label="Decrease quantity" data-id="element-50" data-mp="s10rar38jnaq">
              <MinusIcon className="w-4 h-4" data-id="element-51" data-mp="11wuceyv0sp44" />
            </button>
            <span className="w-10 text-center font-medium" data-id="element-52" data-mp="16qgczsnwt2jk">{quantity}</span>
            <button onClick={() => updateQuantity(product.id, quantity + 1)} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition-colors" aria-label="Increase quantity" data-id="element-53" data-mp="1bo8e9dag210f">
              <PlusIcon className="w-4 h-4" data-id="element-54" data-mp="1kpprmnwgvolf" />
            </button>
          </div>

          {/* Price */}
          <div className="text-right" data-id="element-55" data-mp="3gsktui6cw1qt">
            <p className="font-semibold text-gray-900" data-id="element-56" data-mp="3cqzm1b8oidnh">
              {formatPrice(product.price * quantity)}
            </p>
            {quantity > 1 && <p className="text-xs text-gray-500" data-id="element-57" data-mp="3qiw5ys071h8s">
                {formatPrice(product.price)} each
              </p>}
          </div>
        </div>
      </div>

      {/* Remove button */}
      <button onClick={() => removeItem(product.id)} className="flex-shrink-0 p-2 text-gray-400 hover:text-red-500 transition-colors" aria-label={`Remove ${product.name} from cart`} data-id="element-58" data-mp="49v2iysq7ygd">
        <TrashIcon className="w-5 h-5" data-id="element-59" data-mp="dbuirovx2yi9" />
      </button>
    </div>;
}